// extracted by mini-css-extract-plugin
module.exports = {"container":"SliderComponent_container___cSt5","pcOnly":"SliderComponent_pcOnly__l6ONN","mobileOnly":"SliderComponent_mobileOnly__KrgZ8"};